// corendon.imora.nl frontend lives on CX43 (Coolify); imora-auth backend lives
// on CX33. We call the backend cross-origin via its canonical hostname. The
// session cookie is set on .imora.nl so it travels with `credentials: include`,
// and CORS on imora-auth allows the corendon origin explicitly.
//
// VITE_API_BASE_URL overrides for local dev (e.g. http://localhost:8787);
// defaults to https://imora.nl so a Docker build with no env still points at
// the production backend.

const API_BASE =
  (import.meta.env.VITE_API_BASE_URL || 'https://imora.nl').replace(/\/$/, '')

async function jsonFetch(path, opts = {}) {
  const r = await fetch(API_BASE + path, {
    ...opts,
    credentials: 'include',
    headers: {
      'content-type': 'application/json',
      ...(opts.headers || {}),
    },
  })
  if (r.status === 204) return null
  let body = null
  try {
    body = await r.json()
  } catch {
    // non-JSON response
  }
  if (!r.ok) {
    const err = new Error(body?.error || `HTTP ${r.status}`)
    err.status = r.status
    err.body = body
    throw err
  }
  return body
}

export async function getMe() {
  try {
    return await jsonFetch('/api/auth/me')
  } catch (e) {
    if (e.status === 401) return null
    throw e
  }
}

// Cross-origin login bounce. Sends user to imora.nl's auth start with a
// return_to back to corendon. The backend stores return_to in a temp cookie
// and uses it to redirect after the OAuth callback succeeds (allowlist:
// any *.imora.nl host).
export function redirectToLogin() {
  const returnTo = encodeURIComponent(window.location.href)
  window.location.href = `https://imora.nl/api/auth/google?return_to=${returnTo}`
}

export async function lookupFlight(args) {
  return jsonFetch('/api/corendon/tools/lookup_flight', {
    method: 'POST',
    body: JSON.stringify(args),
  })
}

export async function lookupBooking(args) {
  return jsonFetch('/api/corendon/tools/lookup_booking', {
    method: 'POST',
    body: JSON.stringify(args),
  })
}

export async function changeFlight(args) {
  return jsonFetch('/api/corendon/tools/change_flight', {
    method: 'POST',
    body: JSON.stringify(args),
  })
}

export async function sendConfirmation(args) {
  return jsonFetch('/api/corendon/tools/send_confirmation', {
    method: 'POST',
    body: JSON.stringify(args),
  })
}
